<template>
  <!-- Mobile / tablet top app bar. Hidden on large screens (≥ 992px), where
       the desktop navbar takes over. -->
  <div class="m-topbar">
    <router-link :to="{ name: DASHBOARD_ROUTE }" class="m-topbar__brand" aria-label="Dashboard">
      <img class="m-topbar__logo" :src="brandLogo" alt="Screenkode" />
    </router-link>
    <div class="m-topbar__actions">
      <button
        v-if="onRefresh"
        type="button"
        class="m-icon-btn"
        :title="refreshing ? 'Refreshing…' : 'Refresh'"
        aria-label="Refresh"
        :disabled="refreshing"
        @click="onRefresh()"
      >
        <i class="pi pi-refresh" :class="{ 'pi-spin': refreshing }"></i>
      </button>
      <span class="m-avatar" :title="displayName">{{ initials }}</span>
    </div>
  </div>
</template>
<script>
import { DASHBOARD_ROUTE } from '@/router/routes';
import { accountDisplayName, accountInitials } from '@/utils/display';
import brandLogo from '@/assets/images/logo.png';

export default {
  name: 'MobileTopbar',
  props: {
    onRefresh: {
      type: Function,
      default: null,
    },
    refreshing: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      DASHBOARD_ROUTE,
      brandLogo,
    };
  },
  computed: {
    account() {
      return this.$store.getters.account.data;
    },
    displayName() {
      return accountDisplayName(this.account);
    },
    initials() {
      return accountInitials(this.account);
    },
  },
};
</script>
<style scoped>
.m-topbar {
  display: none;
}

@media (max-width: 991.98px) {
  .m-topbar {
    display: flex;
    flex: none;
    align-items: center;
    justify-content: space-between;
    height: 56px;
    padding: 0 14px;
    background: var(--color-bg-canvas);
    border-bottom: 1px solid var(--color-border);
  }

  .m-topbar__brand {
    display: inline-flex;
    align-items: center;
  }

  .m-topbar__logo {
    height: 26px;
    width: auto;
    object-fit: contain;
  }

  .m-topbar__actions {
    display: flex;
    align-items: center;
    gap: 6px;
  }

  .m-icon-btn {
    width: 38px;
    height: 38px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    background: transparent;
    border: 1px solid transparent;
    border-radius: var(--radius-md);
    color: var(--color-text-secondary);
    cursor: pointer;
    transition: background-color .15s ease, color .15s ease;
  }

  .m-icon-btn:hover {
    background: var(--color-bg-muted);
    color: var(--color-primary-hover);
  }

  .m-icon-btn:disabled {
    cursor: wait;
    color: var(--color-primary-hover);
  }

  .m-icon-btn .pi {
    font-size: 1rem;
  }

  .m-avatar {
    width: 34px;
    height: 34px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    background: var(--color-primary);
    color: var(--color-text-on-primary);
    font-size: 0.72rem;
    font-weight: 700;
    margin-left: 2px;
  }
}
</style>
